import { Action } from "redux";

export const SELECT_ORGANIZATION_FAIL = "SELECT_ORGANIZATION_FAIL";

export interface SelectOrganizationFailAction extends Action {
  type: "SELECT_ORGANIZATION_FAIL";
  organizationKeyName: string;
}

export const selectOrganizationFailAction = (
  organizationKeyName: string
): SelectOrganizationFailAction => ({
  type: SELECT_ORGANIZATION_FAIL,
  organizationKeyName,
});
